function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCallVideoOni = function SvgCallVideoOni(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M16.667 15.512v.944c0 .978-.793 1.772-1.77 1.772H3.8c-.978 0-1.77-.794-1.77-1.772V7.544c0-.978.793-1.772 1.77-1.772h11.086c.978 0 1.77.794 1.77 1.772v.944l4.17-1.808a.8.8 0 0 1 .758.065.8.8 0 0 1 .361.669v9.172a.8.8 0 0 1-.361.669.8.8 0 0 1-.758.065l-4.17-1.808zm-1.6-5.834-.001-.026V7.544a.17.17 0 0 0-.17-.172H3.8a.17.17 0 0 0-.17.172v8.912a.17.17 0 0 0 .17.172h11.086a.17.17 0 0 0 .17-.172v-2.148a.8.8 0 0 1 1.119-.749l4.17 1.808V8.633l-4.17 1.808a.8.8 0 0 1-1.053-.416.8.8 0 0 1-.065-.347z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCallVideoOni);
export default ForwardRef;